import {Menu} from '@mantine/core';
import {type FC, useState} from 'react';
import {
  MdDomain,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
  MdReport,
} from 'react-icons/md';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {ShareButtonsForleftSideBar} from '../../../../../shared/components/ShareButtonsForleftSideBar';
import {EntryButton} from './EntryButton';

type Props = {
  companyId: number;
  title: string;
  currentUrl: string;
  entryURL?: string;
  hasReport: boolean;
};

export const CompanyContentList: FC<Props> = ({
  companyId,
  title,
  currentUrl,
  entryURL,
  hasReport,
}) => {
  return (
    <div>
      <div className="w-full bg-white-1 p-16">
        {companyId && (
          <CommonLink
            href={`/company/${companyId}`}
            className="text-base text-link pc:hover:opacity-80 leading"
          >
            企業情報
          </CommonLink>
        )}
        <p className="text-base font-bold text-black-1">募集情報</p>
        {hasReport && (
          <CommonLink
            href={`/company/${companyId}/experiences`}
            className="text-base text-link pc:hover:opacity-80 leading"
          >
            ES・体験記
          </CommonLink>
        )}
      </div>
      <div className="bg-background-2 p-16 shadow-bottom">
        {entryURL && <EntryButton entryURL={entryURL} isLarge={false} />}
        <ShareButtonsForleftSideBar title={title} currentUrl={currentUrl} />
      </div>
    </div>
  );
};

type CompanyContentListMenuProps = {
  companyId: number;
  hasReport: boolean;
};

export const CompanyContentListMenu: FC<CompanyContentListMenuProps> = ({
  companyId,
  hasReport,
}) => {
  const [opened, setOpened] = useState(false);
  return (
    <Menu position="bottom-start" withArrow>
      <Menu.Target>
        <div
          className="flex items-center"
          onClick={() => {
            setOpened((prev) => !prev);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setOpened((prev) => !prev);
            }
          }}
        >
          <div>関連ページ</div>
          {opened ? (
            <MdOutlineKeyboardArrowUp size={20} />
          ) : (
            <MdOutlineKeyboardArrowDown size={20} />
          )}
        </div>
      </Menu.Target>
      <Menu.Dropdown>
        {companyId && (
          <Menu.Item icon={<MdDomain size={20} />}>
            <CommonLink
              href={`/company/${companyId}`}
              className="text-base pc:hover:opacity-80 leading"
            >
              企業情報
            </CommonLink>
          </Menu.Item>
        )}
        {hasReport && (
          <Menu.Item icon={<MdReport size={20} />}>
            <CommonLink
              href={`/company/${companyId}/experiences`}
              className="text-base pc:hover:opacity-80 leading"
            >
              ES・体験記
            </CommonLink>
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
